// Supabase configuration from environment variables
// For local development, create a .env.local file based on .env.example

// Scrub literal "\n" and surrounding whitespace that can leak into env vars
// when they're added to Vercel via piped input (same hygiene as src/config/auth.ts).
export const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.replace(/\\n/g, '').trim();
export const publicAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.replace(/\\n/g, '').trim();

// Validate required environment variables
if (!supabaseUrl) {
  console.error('Missing VITE_SUPABASE_URL environment variable');
}
if (!publicAnonKey) {
  console.error('Missing VITE_SUPABASE_ANON_KEY environment variable');
}

// Legacy exports for backwards compatibility
// TODO: Remove after all imports are updated
export const projectId = supabaseUrl?.replace('https://', '').replace('.supabase.co', '') || '';
